/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type AnalyticsPageCategory = typeof AnalyticsPageCategory[keyof typeof AnalyticsPageCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsPageCategory = {
  LOGIN: 'LOGIN',
  CHAT: 'CHAT',
  NOT_FOUND: 'NOT_FOUND',
  LOGOUT: 'LOGOUT',
  HOME: 'HOME',
  ONBOARDING: 'ONBOARDING',
  SETTINGS: 'SETTINGS',
  WELLNESS: 'WELLNESS',
  SESSION: 'SESSION',
  REHAB: 'REHAB',
  STATS: 'STATS',
  COMMUNITY: 'COMMUNITY',
  HABIT: 'HABIT',
  PILLS: 'PILLS',
  PATIENT_BOARD: 'PATIENT_BOARD',
  ACCEPT_INVITATION: 'ACCEPT_INVITATION',
  CONFIG_CHAT: 'CONFIG_CHAT',
  CONFIG_CLINIC: 'CONFIG_CLINIC',
  CONFIG_PHYSIOS: 'CONFIG_PHYSIOS',
  CONFIG_PROFILE: 'CONFIG_PROFILE',
  FEEDBACK: 'FEEDBACK',
  INBOX: 'INBOX',
  KANBAN: 'KANBAN',
  REGISTER: 'REGISTER',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  PASSWORD_RESET: 'PASSWORD_RESET',
} as const;
